import { useEffect } from "react";
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from "react-redux";

import AppRouter from './routes/AppRouter';

import store from "./redux/store";

const App = () => {
  useEffect(() => {

    // Connect MQTT
    //mqttService.connect();

    return () => {
    }
  }, [])

  return (
    <Provider store={store}>
      <Router>
        <AppRouter />
      </Router >
    </Provider>
  )
}
export default App;